/* eslint-disable */

import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { composeWithDevTools } from 'redux-devtools-extension';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import rootReducer from './reducers';
import sagas from './sagas';

const configureStore = (history, preloadedState, customMiddleware) => {
  const intercept = store => next => (action) => {
    if (
      customMiddleware !== null
      && customMiddleware !== undefined
      && action.type === 'SEND_EVENT_PARENT'
    ) {
      console.log('llamando al parent desde GlobalDoc_Portal_Wizard::');
      customMiddleware(action);
    }

    const result = next(action);
    return result;
  };


  const initialState = {};
  const middleware = [];
  const sagaMiddleware = createSagaMiddleware();

  const enhancers = [applyMiddleware(...middleware,
    sagaMiddleware, routerMiddleware(history), intercept)];

  const store = createStore(
    connectRouter(history)(rootReducer), // new root reducer with router state
    initialState,
    composeWithDevTools(compose(...enhancers)),
  );
  sagaMiddleware.run(sagas, {});

  return store;
};


export default configureStore;
